import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from '../utils.class';

@Pipe({
    name: 'minutes',
})
export class MinutesPipe implements PipeTransform {

    transform(value: number | string, hideEmpty = true): string {
        if (hideEmpty && parseInt((value ?? 0) as string) === 0) {
            return '';
        }
        return Utils.minutes(typeof value === 'string' ? parseFloat(value) : value);
    }

}
